/**
 * Shared @tanstack/react-query QueryClient singleton.
 *
 * Extracted from App.tsx (SHA-71) so non-React modules — specifically
 * authStore.ts — can reach the same cache instance and call
 * `queryClient.clear()` on logout/login without a circular import
 * (App.tsx -> authStore.ts -> App.tsx).
 *
 * There must be exactly ONE QueryClient instance for the whole app; import
 * this module everywhere a QueryClient is needed instead of constructing a
 * new one.
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 1,
    },
  },
});
